import { render, staticRenderFns } from "./EmailHealth.vue?vue&type=template&id=61732cc2&scoped=true"
import script from "./EmailHealth.vue?vue&type=script&lang=js"
export * from "./EmailHealth.vue?vue&type=script&lang=js"
import style0 from "./EmailHealth.vue?vue&type=style&index=0&id=61732cc2&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61732cc2",
  null
  
)

export default component.exports